export default __webpack_public_path__ + "static/media/lock-ani1.9319cdf9.gif";